import { render, staticRenderFns } from "./CDRTable.vue?vue&type=template&id=9cf73636"
import script from "./CDRTable.vue?vue&type=script&lang=ts"
export * from "./CDRTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports